import { useSelector } from "@xstate/react";
import { gameMachine } from "@machines/gameMachine.js";
import { createActor } from "xstate";

// The root game actor is created once and shared across the app.
export const gameActor = createActor(gameMachine).start();

/** Returns the current game machine snapshot and the actor's send function. */
export function useGameMachine() {
  const snapshot = useSelector(gameActor, (s) => s);
  return [snapshot, gameActor.send] as const;
}
